import { render, staticRenderFns } from "./ColorCard.vue?vue&type=template&id=9275aa8a"
import script from "./ColorCard.vue?vue&type=script&lang=js"
export * from "./ColorCard.vue?vue&type=script&lang=js"
import style0 from "./ColorCard.vue?vue&type=style&index=0&id=9275aa8a&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports